export const SET_ATLAS_IMAGE_ANIM: String = 'SET_ATLAS_ANIM';
export const SET_ATLAS_JSON_ANIM: String = 'SET_ATLAS_JSON_ANIM';
export const SET_ATLAS_ANIM_ANIM: String = 'SET_ATLAS_ANIM_ANIM';
export const RESET_ATLAS_ANIM: String = 'RESET_ATLAS_ANIM';

export interface ZoomAnimAction {
    type: typeof SET_ATLAS_IMAGE_ANIM,
    payload: []
}

export const SetAtlasImageAnimAction = (payload: any): ZoomAnimAction => {
    return {
        type: SET_ATLAS_IMAGE_ANIM,
        payload
    }
}

export const SetAtlasJSONAnimAction = (payload: any): ZoomAnimAction => {
    return {
        type: SET_ATLAS_JSON_ANIM,
        payload
    }
}

export const SetAtlasAnimAnimAction = (payload: any): ZoomAnimAction => {
    return {
        type: SET_ATLAS_ANIM_ANIM,
        payload
    }
}

export const ResetAtlasAction = () => {
    return {
        type: RESET_ATLAS_ANIM
    }
}